export default "__VITE_ASSET__DDiEy8bq__"